module.exports = __webpack_public_path__ + "static/WT_Information_Card-Read_Only-df4992d44aa01202e3d6fead9b156939.png";